import { T } from "@freightsimple/ui-core/Typography/T";
import {
  daysInLocalDateRange,
  formatLocalDate,
} from "@freightsimple/time/helpers";
import { type LocalDate } from "@freightsimple/time/branded-types";

/**
 * The window every figure on the tab below was computed over.
 *
 * Repeated on each tab rather than stated once in the page header, because the
 * header scrolls away and the numbers do not — a carrier reading a win rate
 * halfway down the page has nothing telling them what period it covers.
 *
 * The day count is the part that earns the line. Whether a figure is worth
 * arguing about depends on how much freight is behind it, and working out that
 * two dates are 91 days apart is arithmetic nobody does.
 *
 * Deliberately silent on which date each figure is anchored to: the window is
 * one range, but bookings count by booking date and win rate by quote date.
 * That belongs on each stat's own tooltip, not in a line that claims to cover
 * all of them.
 */
export function PerformanceWindow({
  range,
}: {
  range: [LocalDate, LocalDate];
}) {
  const days = daysInLocalDateRange(range[0], range[1]);
  return (
    <T size="xs" color="muted">
      {formatLocalDate(range[0], "MMM D, YYYY")} to{" "}
      {formatLocalDate(range[1], "MMM D, YYYY")} · {days.toLocaleString()}{" "}
      {days === 1 ? "day" : "days"}
    </T>
  );
}
